import React from "react";
import "./styles/index.scss";
import AppRouter from "./Routes";

export default function App() {
  return <AppRouter />;
}
